import type { ReactNode } from "react";

export function ArticleBody({ body }: { body?: string }) {
  if (!body) return <p>Текст материала готовится.</p>;
  const lines = body.replace(/<[^>]*>/g, "").split(/\n/);
  const nodes: ReactNode[] = [];
  let list: string[] = [];
  const flush = () => { if (list.length) { nodes.push(<ul key={`list-${nodes.length}`}>{list.map((item, index) => <li key={index}>{inline(item)}</li>)}</ul>); list = []; } };
  lines.forEach((line) => {
    const value = line.trim();
    if (value.startsWith("- ")) { list.push(value.slice(2)); return; }
    flush();
    if (!value) return;
    if (value.startsWith("### ")) nodes.push(<h3 key={nodes.length}>{inline(value.slice(4))}</h3>);
    else if (value.startsWith("## ")) nodes.push(<h2 key={nodes.length}>{inline(value.slice(3))}</h2>);
    else if (value.startsWith("# ")) nodes.push(<h2 key={nodes.length}>{inline(value.slice(2))}</h2>);
    else nodes.push(<p key={nodes.length}>{inline(value)}</p>);
  });
  flush();
  return <div className="prose">{nodes}</div>;
}

function inline(text: string): ReactNode {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((part, i) => part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : part);
}
